var tpl = require('./history-item.ejs');
module.exports = function(json){
	var _ = require('underscore');
	return tpl({ data: json, _: _ });
};



//////////////////
// WEBPACK FOOTER
// ./htdocs/assets/js/_src/more-history/index.js
// module id = 39
// module chunks = 0